import { z } from 'zod';

export const WORKFLOW_STATUSES = ['Draft', 'Published', 'Archived'] as const;

// Archived workflows are hidden unless picked in the status filter, which still offers them.
export const DEFAULT_WORKFLOW_STATUSES = WORKFLOW_STATUSES.filter(
  (status) => status !== 'Archived'
);

export const workflowsFiltersSchema = z.object({
  name: z.string().min(1).optional().catch(undefined),
  status: z.array(z.enum(WORKFLOW_STATUSES)).optional().catch(undefined),
  runSchema: z.array(z.string().min(1)).optional().catch(undefined),
});

export type WorkflowsFilterValues = z.infer<typeof workflowsFiltersSchema>;
